import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import { SecretsStorageApi } from '@internal/backstage-plugin-devops-secrets-storage-react';
import {
  DEVOPS_SECRETS_STORAGE_PLUGIN_ID,
  SECRETS_STORAGE_API_PREFIX,
} from '@internal/backstage-plugin-devops-secrets-storage-common';

const DEFAULT_TTL_MINUTES = 30;

export class SecretsStorageApiClient implements SecretsStorageApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl(DEVOPS_SECRETS_STORAGE_PLUGIN_ID);
  }

  async getTemporarySecret(key: string): Promise<string | undefined> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/${SECRETS_STORAGE_API_PREFIX}/secret/${encodeURIComponent(
      key,
    )}`;
    const response = await this.fetchApi.fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status === 404) {
      return undefined;
    }
    if (!response.ok) {
      throw new Error(
        `Secrets storage GET failed: ${response.status} ${response.statusText}`,
      );
    }

    const body = (await response.json()) as { key: string; value: string };
    return body.value;
  }

  async setTemporarySecret(
    key: string,
    value: string,
    ttl_minutes: number = DEFAULT_TTL_MINUTES,
  ): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/${SECRETS_STORAGE_API_PREFIX}/secret`;
    const response = await this.fetchApi.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key, value, ttl_minutes }),
    });

    if (!response.ok) {
      throw new Error(
        `Secrets storage SET failed: ${response.status} ${response.statusText}`,
      );
    }
  }

  async deleteTemporarySecret(key: string): Promise<void> {
    const baseUrl = await this.getBaseUrl();
    const url = `${baseUrl}/${SECRETS_STORAGE_API_PREFIX}/secret/${encodeURIComponent(
      key,
    )}`;
    const response = await this.fetchApi.fetch(url, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error(
        `Secrets storage DELETE failed: ${response.status} ${response.statusText}`,
      );
    }
  }
}
